<h6 class="u-borderBottom-grey100 mat-dialog-title--fullWidth" mat-dialog-title>
  Book a Product Demo
</h6>
<ng-container *ngIf="!hasSubmitted">
  <div class="u-marginBottom-24 color-grey-300">
    Get your organization on Ten Thousand Coffees.
  </div>
  <form class="u-padding-24-0" mat-dialog-content [formGroup]="form">
    <mat-form-field
      [ngStyle]="{ width: '100%' }"
      class="u-display-block"
      appearance="outline"
    >
      <mat-label>Email</mat-label>
      <input
        matInput
        formControlName="email"
        [maxLength]="INPUT_FORM_CHAR_LIMIT"
        autocomplete="off"
        type="email"
        required
      />
    </mat-form-field>
    <mat-form-field
      [ngStyle]="{ width: '100%' }"
      class="u-display-block"
      appearance="outline"
    >
      <mat-label>Phone Number</mat-label>
      <input
        matInput
        formControlName="phone_number"
        [maxLength]="INPUT_FORM_CHAR_LIMIT"
        autocomplete="off"
      />
    </mat-form-field>
    <mat-form-field
      [ngStyle]="{ width: '100%' }"
      class="u-display-block"
      appearance="outline"
    >
      <mat-label>First and Last Name</mat-label>
      <input
        matInput
        formControlName="full_name"
        [maxLength]="INPUT_FORM_CHAR_LIMIT"
        autocomplete="off"
        required
      />
    </mat-form-field>
    <mat-form-field
      [ngStyle]="{ width: '100%' }"
      class="u-display-block"
      appearance="outline"
    >
      <mat-label>Organization</mat-label>
      <input
        matInput
        formControlName="organization_name"
        [maxLength]="INPUT_FORM_CHAR_LIMIT"
        autocomplete="off"
        required
      />
    </mat-form-field>
    <mat-form-field
      [ngStyle]="{ width: '100%' }"
      class="u-display-block u-marginBottom-24"
      appearance="outline"
    >
      <mat-label>Message</mat-label>
      <textarea
        matInput
        #input
        formControlName="message"
        [maxLength]="TEXT_AREA_FORM_CHAR_LIMIT"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        autocomplete="off"
        required
      >
      </textarea>
      <mat-hint align="end">
        {{ input.value.length || 0 }} / {{ TEXT_AREA_FORM_CHAR_LIMIT }}
      </mat-hint>
      <mat-hint> What are you interested in learning about? </mat-hint>
    </mat-form-field>
  </form>
  <mat-dialog-actions
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
    class="u-borderTop-grey100"
    [ngStyle]="{
      'margin-left': '-24px',
      'margin-right': '-24px',
      padding: '8px'
    }"
  >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-button
      color="primary"
      [disabled]="!form.valid"
      (click)="submitForm(form)"
    >
      Send
    </button>
  </mat-dialog-actions>
</ng-container>
<ng-container *ngIf="hasSubmitted">
  <div class="u-padding-24-0" [ngSwitch]="submittedState" mat-dialog-content>
    <ng-container *ngSwitchCase="SUBMITTED_STATES.success">
      We sent your request to our team to schedule a product tour and see if
      there's a way to team up!
    </ng-container>
    <ng-container *ngSwitchCase="SUBMITTED_STATES.serverError">
      You've already requested a tour and we should be in touch we you shortly.
      If you really need to contact our team you can reach us at
      help@tenthousandcoffees.com.
    </ng-container>
    <ng-container *ngSwitchCase="SUBMITTED_STATES.serverFailure">
      Something went wrong. Please try again in a little bit.
    </ng-container>
  </div>
  <mat-dialog-actions
    fxLayout="row"
    fxLayoutAlign="end center"
    [ngStyle]="{
      'margin-left': '-24px',
      'margin-right': '-24px',
      padding: '8px'
    }"
    [ngSwitch]="submittedState"
  >
    <ng-container *ngSwitchCase="SUBMITTED_STATES.serverFailure">
      <button mat-button color="primary" (click)="resetState()">
        Try Again
      </button>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <button mat-button color="primary" mat-dialog-close>Dismiss</button>
    </ng-container>
  </mat-dialog-actions>
</ng-container>
